import {useResourceContext, useTranslate} from "react-admin";

export interface LabelProps {
  label: string;
  resource?: string;
}

export const Label = (props: LabelProps) => {
  const t = useTranslate();

  const resource = useResourceContext({resource: props.resource});

  if (!resource) {
    throw new Error("Query key or resource key is required");
  }

  return <>{t(`resources.${resource}.fields.${props.label}`, {_: props.label})}</>
}